module.exports = __webpack_public_path__ + "img/scenes_14.ef7960cd.png";